import { BackButton } from "../buttons/BackButton";
import { Column } from "./Column";
import { Row } from "./Row";

export function RecordDetailsHeader(props: { backLabel: string; backUrl: string; title: string }) {
  const { backLabel, backUrl, title } = props;

  return (
    <Column>
      <Row sx={{ mb: "8px" }}>
        <BackButton url={backUrl}>{backLabel}</BackButton>
      </Row>
      <h2 style={{ margin: "0 0 10px", lineHeight: 1.2 }}>{title}</h2>
    </Column>
  );
}
